/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Filter_Awaiting_ApprovalInputs */



/**
* | output |
* | --- |
* | "Awaiting approval" |
*
* @param {Partner_Org_Filter_Awaiting_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_filter_awaiting_approval = /** @type {((inputs?: Partner_Org_Filter_Awaiting_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Filter_Awaiting_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warten auf Freigabe")
	return /** @type {LocalizedString} */ ("Awaiting approval")
});